import React from 'react'
import { ContentContainer, PublicationRow } from '@/components/styles'
import DefaultPublicationResultHeader from '@/components/shared/publicationResultHeader'
import SaveToLocalCheckbox from '@/components/shared/saveToLocalCheckbox'
import { Panel, Pagination } from 'rsuite'
import cn from 'classnames'
import styles from '../../../publications/publications.module.scss'
import useTranslation from '@/hooks/useTranslation'
import { i18nL10nSelectors } from '@/store/i18nL10n'
import { useSelector } from 'react-redux'
import { i18nConstants, customerHelper } from '@tweddle-se-team/common/constants'
import { customerId } from '@/utils/env'
import SubaruPublicationResultHeader from './publicationResultHeader'
import NoticeBox from './noticeBox'
import { useIsMobile } from '@/hooks/useIsMobile'
import DesktopPublicationRow from './desktopPublicationRow'

const { CUSTOMER_IDS } = customerHelper

const publicationResultHeaderMapper = {
  [CUSTOMER_IDS.SUBARU]: SubaruPublicationResultHeader,
  [CUSTOMER_IDS.TME]: DefaultPublicationResultHeader,
  [CUSTOMER_IDS.NORDICS]: SubaruPublicationResultHeader
}

const MobilePublicationRow = ({
  item,
  publicationTypes,
  user,
  isInFrame,
  publicationRowClassName,
  withPartNumber,
  customerId
}) => {
  const PublicationResultHeader = publicationResultHeaderMapper[customerId] || DefaultPublicationResultHeader

  return (
    <PublicationRow className={cn('mb-20', publicationRowClassName)}>
      <PublicationResultHeader
        publicationTypes={publicationTypes}
        publication={item}
        user={user}
        showDownloadOption={!item.contents?.ditaId}
        cached={false}
        withPartNumber={withPartNumber}
      />
      {!isInFrame && <SaveToLocalCheckbox publication={item} />}
    </PublicationRow>
  )
}

const Manuals = ({
  data = [],
  publicationTypes,
  user,
  isInFrame,
  total,
  limit,
  page,
  onPageChange,
  publicationRowClassName,
  withPanel = true,
  withPartNumber = true,
  noPublications: noPublicationsComponent
}) => {
  const t = useTranslation()
  const locale = useSelector(state => i18nL10nSelectors.selectLocale(state))
  const { rtlLanguagesISO2Codes } = i18nConstants
  const isMobile = useIsMobile()

  const publicationRows = data.map(item =>
    isMobile ? (
      <MobilePublicationRow
        key={item._id}
        item={item}
        publicationTypes={publicationTypes}
        user={user}
        isInFrame={isInFrame}
        publicationRowClassName={publicationRowClassName}
        withPartNumber={withPartNumber}
        customerId={customerId}
      />
    ) : (
      <DesktopPublicationRow
        key={item._id}
        item={item}
        publicationTypes={publicationTypes}
        user={user}
        isInFrame={isInFrame}
        publicationRowClassName={publicationRowClassName}
        withPartNumber={withPartNumber}
      />
    )
  )

  const showNoticeBox = locale === 'es'

  return (
    <ContentContainer $rightAlign={rtlLanguagesISO2Codes.includes(locale)}>
      {!data.length && noPublicationsComponent}
      {withPanel ? (
        <Panel
          header={`${t('digital_first_topic_type_manual')} (${data.length})`}
          collapsible
          defaultExpanded
          className={styles.publicationsPanel}
        >
          {publicationRows}
        </Panel>
      ) : (
        publicationRows
      )}
      {total > limit && (
        <div className="flex-c">
          <Pagination
            prev
            last
            next
            first
            size="lg"
            pages={Math.ceil((total || 1) / limit)}
            activePage={page}
            onSelect={onPageChange}
            limit={limit}
          />
        </div>
      )}
      {showNoticeBox && (
        <NoticeBox message="Estamos creciendo. Mientras ciertas publicaciones todavía no están disponibles en español, puedes explorar todo el contenido en Inglés." />
      )}
    </ContentContainer>
  )
}

export default Manuals
